import { Tabs } from '@heroui/react'
import { useControlled } from '@mui/material'

export type SegmentedControlOption<T> = {
  value: T
  label: string
}

export type SegmentedControlProps<T> = {
  label: string
  options: SegmentedControlOption<T>[]
  defaultValue?: string
  value?: string
  onChange?: (value: string) => void
}

export const SegmentedControl = <T extends string | number>({
  label,
  options,
  defaultValue,
  value: valueProp,
  onChange,
}: SegmentedControlProps<T>) => {
  const [value, setValue] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'SegmentedControl',
  })

  const handleSelectionChange = (next: string) => {
    setValue(next)
    onChange?.(next)
  }

  return (
    <Tabs
      variant="primary"
      selectedKey={value}
      onSelectionChange={key => handleSelectionChange(String(key))}
    >
      <Tabs.ListContainer>
        <Tabs.List aria-label={label} className="w-full">
          {options.map(option => (
            <Tabs.Tab
              key={String(option.value)}
              id={String(option.value)}
              className="flex-1 whitespace-nowrap"
            >
              {option.label}
              <Tabs.Indicator />
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.ListContainer>
    </Tabs>
  )
}
